import { emptyDecorator } from '@/catalog/constants/emptyDecorator';
import { FieldType } from '@/catalog/constants/fieldTypes';
import { ALL_CONTEXTS } from '@/common/constants/context';
import Diamond from '@/product/entity/Diamond';
export const FIELD_GIRDLE_MM = {
    key: 'girdleWideBezelMma',
    label: 'Girdle',
    fullLabel: 'Girdle, mm',
    type: FieldType.Scalar,
    spGroupId: null,
    icon: 'metrics-girdle',
    getter(p) {
        if (p instanceof Diamond && p.reportData) {
            return p.reportData?.girdleBezel !== null ? `${p.reportData.girdleBezel} mm` : null;
        }
        return null;
    },
    getterPlain(p) {
        if (p instanceof Diamond && p.reportData) {
            return p.reportData?.girdleBezel !== null ? p.reportData.girdleBezel : null;
        }
        return null;
    },
    decorator: emptyDecorator,
    iteratee: null,
    contexts: ALL_CONTEXTS,
};
